module.exports = __webpack_public_path__ + "static/media/2.417995a5.jpg";